module.exports = __webpack_public_path__ + "img/IMG_2310.d4a7e15f.png";